/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tick': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" d="M46.23 8.9a2.78 2.78 0 0 1-.14 3.98L18.42 38.24a2.92 2.92 0 0 1-3.93 0L1.9 26.71a2.78 2.78 0 0 1-.13-3.98 2.92 2.92 0 0 1 4.06-.14l10.61 9.73L42.16 8.76a2.92 2.92 0 0 1 4.07.13z" clip-rule="evenodd"/>'
  }
})
